import phone from 'phone';
import { adjustPhone } from '../adjustPhone';

export const isPhoneValid = (phoneValue) => phone(adjustPhone(phoneValue)).isValid;
